import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/envs/environnement';

declare let gtag: Function;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {

    private readonly trackingId = environment.gaTrackingId;
    private readonly apiUrl = environment.baseUrl;
    private gaLoaded = false;

    // Identifiant de session persistant pour comptage de visiteurs uniques
    private readonly sessionId = this.getOrCreateSessionId();

    constructor(private http: HttpClient) {}

    /** À appeler une seule fois au démarrage de l'app */
    init(): void {
        if (this.trackingId) {
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${this.trackingId}`;
            document.head.appendChild(script);

            (window as any).dataLayer = (window as any).dataLayer || [];
            (window as any).gtag = function () { (window as any).dataLayer.push(arguments); };
            gtag('js', new Date());
            gtag('config', this.trackingId, { send_page_view: false });
            this.gaLoaded = true;
        }
    }

    /** Envoyer une page vue — GA4 + backend maison */
    trackPageView(url: string): void {
        // GA4
        if (this.gaLoaded && this.trackingId) {
            gtag('config', this.trackingId, { page_path: url });
        }

        // Backend maison (fire-and-forget, uniquement sur les pages publiques)
        if (url.startsWith('/public') || url === '/' || url === '') {
            this.http.post(`${this.apiUrl}/analytics/pageview`, {
                page: url,
                sessionId: this.sessionId,
                referrer: document.referrer || null
            }).subscribe({ error: () => {} });
        }
    }

    /** Envoyer un événement personnalisé */
    trackEvent(eventName: string, params: Record<string, any> = {}): void {
        if (!this.gaLoaded || !this.trackingId) return;
        gtag('event', eventName, params);
    }

    private getOrCreateSessionId(): string {
        const key = 'sgmao_sid';
        let sid = sessionStorage.getItem(key);
        if (!sid) {
            sid = crypto.randomUUID();
            sessionStorage.setItem(key, sid);
        }
        return sid;
    }
}
